import { ZoomControls } from "frontend/canvas-controls/zoom-controls/zoom-controls";
import { useFooterContext } from "frontend/context/footer-context";
import { useAtomValue } from "jotai";
import React from "react";
import { TipName } from "shared/datamodel/schemas";
import { Point } from "shared/datamodel/schemas/canvas-element";
import { stageRefAtom } from "state-atoms/general-atoms";
import { posScaleAtom } from "state-atoms/stage-atoms";

export const ZoomView = () => {
  const posScale = useAtomValue(posScaleAtom);
  const stageRefAtomValue = useAtomValue(stageRefAtom);

  const { onChangePosScale, onOrgChartTipClick } = useFooterContext();
  return (
    <ZoomControls
      key="zoom-button"
      scale={posScale.scale}
      position={posScale}
      onZoom={(scale: number, position: Point) => {
        onChangePosScale({ scale, x: position.x, y: position.y });
      }}
      tipName={TipName.walkthroughExploreOrgChart}
      onTipActionClick={onOrgChartTipClick}
      stageRef={stageRefAtomValue ?? undefined}
    />
  );
};
